<ion-header class="m-operation-or-reject-reason-header">
  <ion-row class="m-operation-or-reject-reason-header__content">
    <ion-col size="9" class="ion-no-padding">
      <div class="title-with-icon">
        <div class="back-icon" (click)="handleCancel()">
          <ion-img [src]="backArrow"></ion-img>
        </div>
        <div>{{ title | translate }}</div>
      </div>
    </ion-col>
    <ion-col size="3" class="ion-no-padding">
      <div class="selected-count">{{ 'input_app_common.selected' | translate }}: {{ selectedLists.length }}</div>
    </ion-col>
  </ion-row>
</ion-header>
<ion-content class="m-operation-or-reject-reason-content">
  <div class="m-operation-or-reject-reason-content__container">
    <div class="selected-bctx">
      <!-- Adding this to prevent scroll to top when we select bottom item -->
    </div>
    <div class="operation-reject-reason-list">
      <monorepo-reject-v2-multi-select
        [lists]="lists"
        [preSelectedList]="selectedLists"
        (selectedList)="handleOperationOrRejectReasonSelection($event)"
      ></monorepo-reject-v2-multi-select>
    </div>
  </div>
</ion-content>
<ion-footer>
  <ion-row class="m-operation-or-reject-reason-footer ion-justify-content-between">
    <ion-col sizeLg="2" sizeMd="4" class="ion-no-padding">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'filter_masterdata_list.selectDeselect' | translate"
        (clickEvent)="handleSelectAll()"
      ></ui-custom-button
    ></ion-col>
    <ion-col sizeLg="4" sizeMd="6" class="ion-no-padding" style="text-align: end">
      <ui-custom-button
        [buttonHeight]="'56px'"
        [buttonType]="'SECONDARY'"
        [btnTxt]="'input_app_common.cancel' | translate"
        (clickEvent)="handleCancel()"
        style="margin-right: 16px"
      ></ui-custom-button>
      <ui-custom-button
        [buttonHeight]="'56px'"
        [btnTxt]="'input_app_common.apply' | translate"
        (clickEvent)="handleApply()"
        [isDisabled]="selectedLists.length === 0"
      ></ui-custom-button>
    </ion-col>
  </ion-row>
</ion-footer>
